import Divider from 'components/Divider/Divider';
import { WearAndTearFeatureItem } from 'lease-signing-flow-v2/components/wear-and-tear-feature-item/wear-and-tear-feature-item';
import { features } from 'lease-signing-flow-v2/constants/wear-and-tear';

export const WearAndTearFeatureList = () => (
  <div className="mt-xl flex flex-row">
    {features.map((feature, index) => (
      <div className="flex flex-1 flex-row justify-around" key={feature.title}>
        <WearAndTearFeatureItem image={feature.image} title={feature.title} />
        {index !== features.length - 1 && (
          <div className="relative h-full w-md">
            <div className="absolute left-[-125px] top-[104px] h-0 w-icons-96x96 translate-x-[90px] translate-y-0 rotate-90">
              <Divider />
            </div>
          </div>
        )}
      </div>
    ))}
  </div>
);
